<template>
  <div class="header">
    <div class="menu">
      <div class="menu_action">
        <i :class="`${isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'} cursor-pointer`" @click="handleCollapse"></i>
      </div>
      <!-- 头部导航 方法一 -->
      <!-- <el-menu v-show="headerList && headerList[0]" :default-active="currentModule"  text-color="#242832" active-text-color="#237FFA" mode="horizontal" @select="handleSelectMenu">
        <el-menu-item v-for="item in headerList" :key="item.id" :index="item.url" >{{item.name}}</el-menu-item>
      </el-menu> -->

      <!-- 头部导航 方法二 -->

      <ul class="el-menu--horizontal el-menu" v-show="headerList && headerList[0]">
        <li class="el-menu-item" :class="{ 'is-active': active === item.url && $route.path !== '/workbench' }" v-for="item in headerList" :key="item.id"
          @click="handleSelectMenu(item.url)">
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <el-button v-auth="'workOrder:hospital:board'" type='primary' round size="small" icon='el-icon-s-platform'
      style="margin-right:10px;" @click="handleFullscreen(2)" v-if="active === '\/orderWall' || sysFlag === 'yxb'">
      客户数据看板
    </el-button>
    <el-button v-auth="'board'" type='primary' round size="small" icon='el-icon-s-platform' style="margin-right:10px;"
      @click="handleFullscreen(1)" v-if="active === '\/orderWall' || sysFlag === 'yxb'">
      数据看板
    </el-button>
    <div class="d-flex align-items-center">
      <div v-if="(active === '\/orderWall' || sysFlag === 'yxb') && TRIALPRODUCTCODE === '2' && msgShowType !== null" class="payment_notice mr-3"
        @click="handleOpenedManually">
        <template v-if="msgShowType">
          您有
          <span>{{ expriryList.length }}</span>
          家客户待付费，
        </template>
        <template v-else>
          <template v-if="currentUserInfo.expiryDays < 0">账号已过期，</template>
          <template v-else>
            剩余
            <span>{{ currentUserInfo.expiryDays }}</span>
            天到期，
          </template>
        </template>
        <span>请点击支付</span>
      </div>
      <el-dropdown v-if="active === '\/orderWall'" :hide-on-click="false" id="guide_help_btn" ref="guide_help_btn"
        class="d-flex align-items-center mr-3" placement="bottom" trigger="click">
        <div class="help_center">
          <i class="iconfont icon-wenhao help_center_icon icon-ic_bangzhuzhongxin"></i>
          <span class="help_center_text">帮助</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item id="helpcenter" @click.native="openHelpDoc">帮助手册</el-dropdown-item>
          <el-dropdown-item @click.native="goToFeedback">意见反馈</el-dropdown-item>
          <!-- <el-dropdown-item @click.native="openGuideModelHandle">新手引导</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <div class="scan-box">
        <img :src="require('@/assets/ic_scan.svg')" class="scan-icon bg-grey" />
        <div class="scan-popover">
          <div class="tip">扫码关注</div>
          <div class="scan-panel">
            <div v-for="(code, index) in codeList" :key="'scan-'+index" class="code-box">
              <img :src="code.qrcode" class="code" />
              <span class="code-name">{{ code.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <el-popover
        popper-class="popover-message-panel"
        placement="bottom-end"
        width="350"
        trigger="click"
        v-model="showMessagePanel">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane label="全部消息" name="all"></el-tab-pane>
          <el-tab-pane label="@我的" name="mine"></el-tab-pane>
        </el-tabs>
        <div v-show="messageLists.length" ref="scrollContainer" @scroll="handleScroll" class="message-box">
          <div v-for="(msg, i) in messageLists" :key="msg.id" @click="showMsgDetail(i, msg)" class="message-item">
            <div class="message-title text-ellipsis" :class="{'unRead': !msg.readFlag}">{{ msg.businessTypeName}}</div>
            <div class="message-time">{{ msg.createTime ? formatDate(msg.createTime, 'YYYY-MM-DD HH:mm:ss') : '--' }}</div>
            <div class="message-remark" v-html="msg.content"></div>
          </div>
        </div>
        <Empty v-show="!messageLists.length" style="padding-top: 50px;" />
        <div class="message-ctrl-bar">
          <div @click="allRead" class="all-read">全部已读</div>
          <div @click="toMessageList" class="read-more">查看全部消息</div>
        </div>
        <el-badge :value="unReadCountFlag ? unReadCountFlag : null" slot="reference" style="margin-right: 25px;">
          <i class="el-icon-bell" style="font-size: 20px;"></i>
        </el-badge>
      </el-popover>
      <el-dropdown trigger="click" id="personl_help_btn" ref="personl_help_btn" class="user_Info"
        @visible-change="visibleChange" :hide-on-click="false" size="normal">
        <div class="cursor-pointer">
          <div class="userInfo_name">
            <div class="userInfo_name-left">
              <img v-if="this.$store.getters.currentUserInfo && this.$store.getters.currentUserInfo.headUrl"
                :src="this.$store.getters.currentUserInfo.headUrl" class="head" />
              <el-avatar v-else icon="el-icon-user-solid" :size="40" class="font-large"></el-avatar>
            </div>
            <!-- 个人用户或者当前企业 -->
            <div class="userInfo_name-right">
              <span class="name">{{ this.$store.getters.currentUserInfo && (this.$store.getters.currentUserInfo.nickName
                ||
                this.$store.getters.currentUserInfo.name) }}</span>
              <div class="name-ellipsis">{{ this.$store.getters.currentUserInfo.isPersonal ? '小紫平台个人用户' : tenantName }}</div>
            </div>
          </div>
          <i :class="[userMenuVisible ? 'el-icon-caret-top' : 'el-icon-caret-bottom', 'el-icon--right']"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <div class="user-switch-quit-box">
            <img v-if="this.$store.getters.currentUserInfo && this.$store.getters.currentUserInfo.headUrl"
              :src="this.$store.getters.currentUserInfo.headUrl" @click="handleRedirectToUserInfo" class="head" />
            <el-avatar v-else @click.native="handleRedirectToUserInfo" icon="el-icon-user-solid" :size="50"></el-avatar>
            <div @click="handleRedirectToUserInfo" class="name">{{ this.$store.getters.currentUserInfo &&
              (this.$store.getters.currentUserInfo.nickName || this.$store.getters.currentUserInfo.name) }}</div>
            <el-popover v-model="visible" placement="left-start" width="400" trigger="hover">
              <company-list :companyLists='companyLists' @refresh="refresh" />
              <div slot="reference" class="company-box">
                <div class="left">
                  <div class="title">切换</div>
                  <div class="name-2">{{ this.$store.getters.currentUserInfo.isPersonal ? '个人用户' : tenantName }}</div>
                </div>
                <div class="right">
                  <i class="el-icon-arrow-right" size="16px"></i>
                </div>
              </div>
            </el-popover>
            <div @click="handleLoginOut" class="quit">
              <img :src="require('@/assets/icon_quit.svg')" />
              退出登录
            </div>
          </div>
        </el-dropdown-menu>
        <!-- <el-dropdown-menu slot="dropdown" class="user_info_drop_menu">
          <el-dropdown-item @click.native="handleRedirectToUserInfo" id="personalcenter">个人中心</el-dropdown-item>
          <el-dropdown-item @click.native="handleLoginOut">退出登录</el-dropdown-item>
        </el-dropdown-menu> -->
      </el-dropdown>
    </div>
    <pay-dialog ref="payDialog" v-model="payDialogVisible" :defaultCheckedId="defaultCheckedId"
      :defaultCheckedName="defaultCheckedName" :isExpiryed="currentUserInfo.expiryDays < 0"
      :productNameType="payNameType" closeable @success="handlePaymentSuccess" />

    <message-detail-dialog ref="messageDetailDialogRef" :detail="currentMessage" @close="handleCloseMessageDialog" />
  </div>
</template>

<script>
import * as Moment from 'dayjs';
import UserApi from '@/api/systemSetting';
import { getProductList } from '@/api/payment';
import AccountApi from '@/api/login';
import { queryCount, queryPage, allUpdateRead } from '@/api/messages';
import PayDialog from './payDialog.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { fullScreen } from '@/utils/fullScreen';
import CompanyList from '@/components/common/companyList/index.vue';
import MessageDetailDialog from '@/views/Workbench/Components/messageDetailDialog.vue';
import Empty from '@/components/empty.vue';

export default {
  name: 'Header',
  components: {
    PayDialog,
    CompanyList,
    MessageDetailDialog,
    Empty,
  },
  data: function () {
    return {
      TRIALPRODUCTCODE: localStorage.userInfo ? JSON.parse(localStorage.userInfo).trialProductCode : '',
      tenantName: localStorage.userInfo ? JSON.parse(localStorage.userInfo).tenantName : '',
      userMenuVisible: false,
      isCollapse: false,
      payDialogVisible: false,
      expriryList: [],
      defaultCheckedId: '',
      defaultCheckedName: '',
      showMessagePanel: false,
      msgShowType: null,
      payNameType: '',
      visible: false,
      companyLists: [],
      sysFlag: 'homePage',

      active: '',
      unReadCountFlag: 0,
      activeTab: 'all',
      copyActiveTab: null,
      hasNextPage: true,
      loading: false,
      messageLists: [],
      currentMessage: {},
      msgPagination: {
        currentPage: 1,
        pageSize: 10,
      },
      codeList: [
        { name: '平台小程序', qrcode: require('@/assets/xiaochengxu.png') },
        { name: '平台公众号', qrcode: require('@/assets/gongzhonghao.png') },
        { name: '平台客服', qrcode: require('@/assets/qiweikefu.png') },
      ],
    };
  },
  watch: {
    // 点击1械导航，还是保持上一个选中状态
    $route (to) {
      let currentMenu = this.menuUrlMap[to.path];
      let url = '';
      if (currentMenu && currentMenu[0] && this.headerList[0]) {
        let info = this.headerList.find(t => t.sysFlag?.toUpperCase() === currentMenu[0].sysFlag?.toUpperCase());
        this.initSysFlag(info);
        url = info?.url || '';
      }
      if (to.path !== '/1xie') {
        this.active = url;
      }
    },
    showMessagePanel (v) {
      if (v) {
        this.$nextTick(() => {
          // this.activeTab = this.copyActiveTab !== '0' ? this.copyActiveTab : 'all';
          this.refreshMessage();
        });
      }
    },
    // activeTab (v) {
    //   this.copyActiveTab = v;
    //   this.$refs.scrollContainer.scrollTop = 0;
    //   v && this.refreshMessage();
    // },
    unReadCount (v) {
      this.unReadCountFlag = v;
    },
  },
  methods: {
    ...mapActions({
      getMenuInfo: 'getMenuInfo',
    }),
    ...mapMutations({
      updateUserInfo: 'UPDATE_USERINFO',
    }),
    handleFullscreen (type) {
      this.$emit('fullScreenChanged', type);
      fullScreen();
    },
    initSysFlag (info) {
      this.sysFlag = info?.sysFlag || '';
    },
    refresh () {
      // this.$emit('refreshAllTabs');
      this.visible = false;
    },
    formatDate (text, format = 'YYYY-MM-DD') {
      return text ? Moment(text * 1).format(format) : '/';
    },
    handleCloseMessageDialog (status) {
      if (status === 1) {
        this.showMessagePanel = false;
      } else {
        setTimeout(() => {
          this.showMessagePanel = true;
        }, 10);
      }
    },
    async allRead () {
      if (!this.messageLists.length) {
        this.showMessagePanel = false;
        return;
      }
      await allUpdateRead();
      this.refreshMessage();
      this.showMessagePanel = false;
    },
    toMessageList () {
      this.showMessagePanel = false;
      this.$router.push({
        name: 'MESSAGES',
      });
    },
    showMsgDetail (i, item) {
      this.messageLists[i].readFlag = 1;
      this.currentMessage = item;
      this.$refs.messageDetailDialogRef.dialogVisible = true;
    },
    refreshMessage () {
      this.hasNextPage = true;
      this.msgPagination.currentPage = 1;
      this.queryMsgCount();
      this.queryMsgList();
    },
    async queryMsgCount () {
      const { employeeMsg } = JSON.parse(this.$local.get('userInfo'));
      const remindUserId = employeeMsg.id;
      const data = await queryCount({ readFlag: 0, remindUserId, onTimeRemindFlag: true });
      this.unReadCountFlag = Number(data.body.unReadCount) || 0;
    },
    handleScroll () {
      const container = this.$refs.scrollContainer;
      // 检查是否滚动到底部
      if (container.offsetHeight + container.scrollTop >= container.scrollHeight - 50) {
        this.loadMore();
      }
    },
    loadMore () {
      if (this.loading) return;
      if (!this.hasNextPage) return;
      this.loading = true;
      this.msgPagination.currentPage += 1;
      this.queryMsgList();
    },
    async queryMsgList () {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const data = await queryPage({
        onTimeRemindFlag: true,
        remindUserId: userInfo.id,
        pageNum: this.msgPagination.currentPage,
        pageSize: this.msgPagination.pageSize,
        messageType: this.activeTab === 'mine' ? 2 : null,
      });
      if (this.msgPagination.currentPage === 1) {
        this.messageLists = data.body.list || [];
      }
      if (this.msgPagination.currentPage > 1 && data.body.list && data.body.list.length) {
        this.messageLists = this.messageLists.concat(data.body.list);
      }
      this.loading = false;
      this.hasNextPage = data.body.total > this.messageLists.length;
    },
    visibleChange (val) {
      this.userMenuVisible = val;
      this.tenantName = this.$local.get('userInfo') ? JSON.parse(this.$local.get('userInfo')).tenantName : '';
      this.companyLists = JSON.parse(this.$local.get('ownerList'));
    },
    handleLoginOut () {
      // 退出操作
      this.$confirm('确认是否要退出？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // 确认操作
        AccountApi.logout().then(() => {
          this.$local.clear();
          this.$session.clear();
          this.$router.push({
            name: 'LOGIN',
          });
        });
      });
    },
    handleCollapse () {
      this.isCollapse = !this.isCollapse;
      this.$emit('collapse', this.isCollapse);
    },
    handleRedirectToUserInfo () {
      this.visible = false;
      this.$router.push({
        name: 'USER_INFO',
      });
    },
    openHelpDoc () {
      window.open('https://www.yuque.com/yixiubao', '_blank');
    },
    goToFeedback () {
      this.$router.push({
        name: 'FeedbackLists',
      });
    },
    // openGuideModelHandle () {
    //   this.$emit('openGuideModel');
    // },
    handlePaymentSuccess () {
      UserApi.getDetailEmploy({ id: this.currentUserInfo.id, findDepartmentFlag: true, findRoleFlag: true }).then(
        (userDetail) => {
          this.$local.set('userInfo', userDetail.body);
          this.updateUserInfo(userDetail.body);
        },
      );
    },
    handleOpenedManually (obj) {
      const { defaultCheckedId, defaultCheckedName, payNameType } = obj;
      this.payDialogVisible = true;
      this.payNameType = payNameType;
      this.defaultCheckedId = defaultCheckedId;
      this.defaultCheckedName = defaultCheckedName;
    },
    showDropdown (step) {
      const docEle = step.options.restOption?.parentId;
      const higNode = step.node;
      if (docEle === 'guide_help_btn') {
        this.$refs.personl_help_btn.hide();
        document.querySelector('#personalcenter').style['z-index'] = '100';
      }
      this.$refs[docEle].show();
      higNode.style['z-index'] = '20000000';
    },

    handleSelectMenu (key) {
      const environment = process.env.VUE_APP_OFFICAL_WEBSITE_YI;
      if (key === '/1xie') {
        window.open(environment, '_blank');
        return;
      }
      this.active = key;
      this.$local.set('active', this.active);
      this.$router.push({
        path: key,
      });
    },
    handleTabClick ({name}) {
      this.activeTab = name;
      this.$refs.scrollContainer.scrollTop = 0;
      name && this.refreshMessage();
    },
  },
  computed: {
    ...mapGetters(['currentUserInfo', 'menuTree', 'menuIdMap', 'menuUrlMap', 'unReadCount']),
    headerList () {
      return this.menuTree.filter(t => t.level === 1 && t.type === 1).sort((a, b) => a.sort - b.sort);
    },
    currentModule () {
      let currentMenu = this.menuUrlMap[this.$route.path];
      if (currentMenu && currentMenu[0] && this.headerList[0]) {
        let info = this.headerList.find(t => t.sysFlag.toUpperCase() === currentMenu[0].sysFlag.toUpperCase());
        this.initSysFlag(info);
        return info.url;
      }
      return '';
    },
  },
  mounted () {
    this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
  },
  created () {
    this.active = this.$store.getters.firstUrl || this.$local.get('active') || '';

    this.queryMsgCount();
    this.$eventBus.$on('openPaymentDialogManually', this.handleOpenedManually);

    if (!this.currentUserInfo) {
      this.payDialogVisible = false;
      return;
    }

    getProductList({ day: 30 }).then((res) => {
      this.msgShowType = res.body.flag;
      this.expriryList = res.body?.pages || [];
    });
    // let expiryDays = parseInt(this.currentUserInfo.expiryDays);
    // // 正式用户提前30天提醒付费
    // if (this.currentUserInfo.isFormal && expiryDays <= 30) {
    //   this.payDialogVisible = true;
    //   return;
    // }
    // // 试用用户提前3天提醒付费
    // if (!this.currentUserInfo.isFormal && expiryDays <= 3) {
    //   this.payDialogVisible = true;
    //   return;
    // }
    // this.payDialogVisible = false;
  },
  beforeDestroy () {
    this.$eventBus.$off('openPaymentDialogManually', this.handleOpenedManually);
    if (this.$refs.scrollContainer) {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    }
  },
};
</script>

<style lang="scss" scoped>
.popover-message-panel {
  .message-box {
    height: 300px;
    overflow: auto;
    .message-item {
      background: #F5F7FA;
      border-radius: 4px;
      margin-bottom: 10px;
      padding: 10px;
      padding-right: 30px;
      font-weight: 400;
      font-size: 12px;
      color: #5F6A7A;
      cursor: default;
      .message-title {
        padding-left: 12px;
        font-size: 14px;
        color: #1F2733;
        position: relative;
        &.unRead {
          &::before {
            content: ' ';
            position: absolute;
            left: 0;
            top: 6px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #FF5959;
          }
        }
      }
      .message-time {
        padding: 3px 12px;
        font-size: 12px;
        color: #929AA6;
      }
      .message-remark {
        padding-left: 12px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  .message-ctrl-bar {
    border-top: 1px solid #eeeeee;
    font-weight: 400;
    font-size: 12px;
    color: #929AA6;
    padding-top: 15px;
    padding-right: 45px;
    padding-left: 17px;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: default;
  }
}
.header {
  height: 56px;
  // line-height: 56px;
  display: flex;
  background: white;
  color: #242832;
  align-items: center;
  padding: 0 30px 0 15px;
  font-size: 14px;
  border-bottom: 1px solid rgba(113, 121, 141, 0.08);

  .menu {
    flex: 1;
    display: flex;

    .el-menu {
      margin-left: 10px;
      flex: 1;
      border: none;

      .el-menu-item {
        height: 46px;
        line-height: 46px;
      }
    }
  }

  .scan-box {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 10px;
    .scan-icon {
      position: absolute;
      display: inline-block;
      width: 37px;
      height: 37px;
    }
    .scan-popover {
      display: none;
      position: absolute;
      top: 40px;
      right: -10px;
      z-index: 9999;
      width: 380px;
      background: #FFFFFF;
      box-shadow: 0px 5px 15px 2px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      padding: 0 10px;
      .tip {
        font-weight: 600;
        font-size: 14px;
        color: #1F2733;
        padding: 16px 25px;
        border-bottom: 1px solid #eeeeee;
      }
      .scan-panel {
        padding: 12px 0;
        display: flex;
        justify-content: space-around;
        .code-box {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          .code {
            width: 100px;
            height: 100px;
          }
          .code-name {
            font-weight: 400;
            font-size: 16px;
            color: #5F6A7A;
            margin-top: 6px;
          }
        }
      }
    }
    &:hover {
      .bg-grey {
        background-color: #eeeeee;
      }
      .scan-popover {
        display: block;
      }
    }
  }

  .logo {
    width: 280px;
    font-size: 16px;
    font-size: 0px;
    vertical-align: middle;
    color: #242832;
  }

  .user_Info {
    color: #242832;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;

    &>div {
      display: flex;
      align-items: center;

      &>div.userInfo_name {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 8px;

        &>span:nth-child(2) {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 120px;
        }

        .head {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
        }

        .userInfo_name-left {

          // margin-right: 10px;
          // display: flex;
          // align-items: center;
          // justify-content: center;
          .el-avatar {
            background: #a1cdfb;
          }
        }

        .userInfo_name-right {
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          .name {
            font-size: 14px;
            font-weight: 600;
            color: #1F2733;
          }

          .name-ellipsis {
            font-size: 12px;
            color: #5F6A7A;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 140px;
          }
        }
      }
    }
  }

  .payment_notice {
    height: 33px;
    background: #fee8c0;
    border-radius: 17px;
    font-size: 14px;
    font-weight: bolder;
    color: #242832;
    line-height: 33px;
    padding: 0 16px;
    letter-spacing: 1px;
    cursor: pointer;

    &>span {
      color: #d20000;
    }
  }

  .menu_action {
    font-size: 18px;
    height: 50px;
    line-height: 50px;
    vertical-align: middle;
  }

  .help_center {
    padding: 5px 12px;

    &:hover {
      color: #0f89ff;
    }

    &_icon {
      color: #0f89ff;
      padding-right: 8px;
    }
  }
}

.user-switch-quit-box {
  width: 350px;
  position: absolute;
  top: 0;
  right: -15px;
  background: #FFFFFF;
  box-shadow: 0px 8px 16px 6px rgba(31, 39, 51, 0.12);
  border-radius: 4px;
  padding: 25px 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  .name {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0 15px;
  }

  .company-box {
    width: 330px;
    background: #F2F4F7;
    border-radius: 4px;
    padding: 5px 0;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 10px;

      .title {
        font-weight: bold;
      }

      .name-2 {
        line-height: 1.5;
        font-size: 12px;
        font-weight: 400;
        color: #929AA6;
      }
    }

    .right {
      padding: 10px;
    }
  }

  .quit {
    cursor: pointer;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #FF5858;
    padding: 10px 0;
    margin-top: 10px;
    border-top: 1px solid #f0f0f0;

    >img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }

  .head {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
}

.user_info_drop_menu {
  min-width: 120px;
}

/deep/ .el-menu-item:hover,
/deep/ .el-menu-item.is-active,
/deep/ .el-menu-item.is-active:hover {
  background: #E2F3FE !important;
  color: #237FFA;
}

.el-menu--horizontal>.el-menu-item {
  color: #242832;
}

.el-menu-item.is-active {
  color: #237FFA;
}

.el-avatar {
  background: #a1cdfb;
}
</style>
